import React, { useState, useEffect, useMemo } from 'react';
import ServiceBannerSection from 'ui/components/organism/ServiceBannerSection';
import BreadCrumbs, { IBreadcrumbs } from 'ui/components/molecules/Breadcrumbs';
import { IFaq } from 'ui/components/molecules/FaqAccordion';
import ServicesListSection from 'ui/components/organism/ServicesListSection';
import FilterServices from 'ui/components/organism/FilterServices';
import SortIcon from 'ui/components/atoms/Icons/SortIcon';
import SortModalContent, { IsortModal } from 'ui/components/atoms/SortModalContent';
import InfoSection from 'ui/components/organism/InfoSection';
import FilterIcon from 'ui/components/atoms/Icons/FilterIcon';
import FilterModalContentServicePackages from 'ui/components/atoms/FilterModalContentServicePackages';
import BtnConfirm from 'ui/components/atoms/BtnConfirm';
import ArrowForward from 'ui/components/atoms/Icons/ArrowForward';
import eventSortCoupon from 'ui/lib/gtm/eventSortCoupon';
import { useSelector } from 'react-redux';
import eventFilterCoupon from 'ui/lib/gtm/eventFilterCoupon';
import { sendDataInChunks } from 'ui/lib/collectData';
import eventViewBannerCoupon from 'ui/lib/gtm/eventViewBannerCoupon';
import { IServicesPackages } from '../../organism/ServicesListSection/interface';
import { useRouter } from 'next/router';
import pageKey from '../../../constants/pageKey';
import eventViewCouponService from '../../../lib/gtm/eventViewCouponService';
import { IRootState } from '../../../store';
import FilterModalContentAccessories from '../../atoms/FilterModalContentAccessories';
import { IFilterOptions } from '../../../interface/accessories.interface';
import eventViewAccessoriesListing from '../../../lib/gtm/eventViewAccessoriesListing';
import dynamic from 'next/dynamic';
import FaqAccordionNoscript from '../../molecules/FaqAccordionNoScript';
import { IMetadata } from '../../atoms/Metadata/interface';
import { SECTION_NAME_SERVICE_COUPON } from '../../../constants/emarsys/service-coupon';

const ModalMobile = dynamic(() => import('ui/components/atoms/ModalMobile'), {
  ssr: false,
});

const FaqAccordion = dynamic(() => import('ui/components/molecules/FaqAccordion'), {
  ssr: false,
});

interface ServiceListingPageTemplateProps {
  breadcrumbItems?: IBreadcrumbs[];
  servicePackages?: IServicesPackages[];
  servicePackagesForFilter?: IServicesPackages[];
  carModel?: IFilterOptions;
  specialOffer?: IFilterOptions;
  faqs?: {
    faqList: IFaq[];
    title: string;
  };
  infoSectionData?: {
    title: string;
    desc: string;
  };
  bannerId?: string;
  bannerTitle?: string;
  bannerDesc?: string;
  bannerImg?: string;
  bannerHeight?: number;
  bannerWidth?: number;
  bannerAltImg?: string;
  tabList?: { name: string; path: string; selected?: boolean }[];
  typeID?: string;
  sortsList?: IsortModal[];
  filterCount?: number;
  freeTextSearch?: string;
  bannerLink?: string;
  isForAccList?: boolean;
  pagination?: {
    currentPage: number;
    pageSize: number;
    sort: string;
    totalPages: number;
    totalResults: number;
  };
  filterAccessories?: any;
  paginationBaseUrl?: string;
  minPrice?: any;
  maxPrice?: any;
  slideMin?: any;
  slideMax?: any;
  setTriggerFilter?: any;
  pickUpOption?: IFilterOptions;
  categoryFilter?: IFilterOptions;
  typeAccFilter?: IFilterOptions;
  isPLPCategory?: boolean;
  accessoriesCategory?: string;
  feature?: string;
  metadata?: IMetadata;
}

const ServiceListingPageTemplate = ({
  breadcrumbItems,
  servicePackages,
  carModel,
  specialOffer,
  faqs,
  infoSectionData,
  bannerId,
  bannerTitle,
  bannerDesc,
  bannerImg,
  bannerAltImg,
  bannerHeight,
  bannerWidth,
  tabList,
  typeID,
  sortsList,
  filterCount,
  freeTextSearch,
  bannerLink,
  servicePackagesForFilter,
  isForAccList = false,
  pagination = null,
  filterAccessories = null,
  paginationBaseUrl = '',
  minPrice,
  maxPrice,
  slideMin,
  slideMax,
  pickUpOption,
  typeAccFilter,
  categoryFilter,
  isPLPCategory = false,
  accessoriesCategory,
  feature,
  metadata,
}: ServiceListingPageTemplateProps) => {
  const [viewSortModal, setViewSortModal] = useState(false);
  const [viewFilterModal, setViewFilterModal] = useState(false);
  const [triggerGTM, setTriggerGTM] = useState(false);
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [collectDataBanner, setcollectDataBanner] = useState([]);
  const [collectDataList, setcollectDataList] = useState([]);
  const { dataCoupon, isGTMReady } = useSelector((state: any) => state.dataGTM);
  const { userData } = useSelector((state: any) => state.auth);
  const { screenSize } = useSelector((state: IRootState) => state.page);

  const selectedCarModels = carModel?.values
    ?.filter((item) => item.selected)
    .map((item) => item.name);

  const accCategory = Array.from(
    new Set(
      servicePackages?.map((e) =>
        e?.accessoriesCategory === undefined || e?.accessoriesCategory === null
          ? 'not available'
          : e?.accessoriesCategory?.toLowerCase()
      ) || ['not available']
    )
  );

  const screenTab = screenSize.width < 1025;
  const accType = ['accessories', 'accessoriesWithAllFilter'];
  const router = useRouter();
  const typeLabel = useMemo(() => {
    return typeID === 'coupon' ? 'kupon' : accType.includes(typeID) ? 'aksesoris' : 'paket';
  }, [typeID]);

  const categoryGTM = useMemo(() => {
    return router?.asPath !== '/'
      ? tabList?.find((e) => e?.path?.includes(router?.asPath))?.name?.toLowerCase()
      : 'semua';
  }, [router]);

  useEffect(() => {
    setTimeout(() => {
      if (!viewFilterModal && isGTMReady) {
        if (collectDataList.length > 0) {
          sendDataInChunks(
            collectDataList,
            collectDataList.length,
            (chunk) => {
              if (accType.includes(typeID)) {
                // ambil query params dari q
                const q = (router.query.q as string) || '';
                // ambil accessories category menggunakan regex
                const match = q.match(/accessoriesCategory:([^:]+)/);
                // ambil value pertama accessories category
                const firstAccCategory = match
                  ? decodeURIComponent(match[1]).replace(/\+/g, ' ')
                  : null;

                eventViewAccessoriesListing(
                  chunk,
                  `aksesoris - ${firstAccCategory ? firstAccCategory : accCategory ? accCategory.join(', ') : 'not available'}`,
                  typeLabel
                );
              } else {
                eventViewCouponService(
                  chunk,
                  router?.asPath !== '/'
                    ? tabList?.find((e) => e?.path?.includes(router?.asPath))?.name?.toLowerCase()
                    : 'semua',
                  typeLabel
                );
              }
            },
            setcollectDataList,
            pageKey?.newCarPurchase
          );
        }
      }
    }, 1500);
  }, [collectDataList, viewFilterModal, isGTMReady]);

  useEffect(() => {
    if (triggerGTM) {
      eventSortCoupon(sortsList?.find((e) => e?.selected)?.name, typeLabel);
      setTriggerGTM(false);
    }
  }, [sortsList?.find((e) => e?.selected)]);

  useEffect(() => {
    if (triggerFilter) {
      eventFilterCoupon(
        dataCoupon,
        carModel?.values.filter((item) => item?.selected)?.map((item) => item?.name?.toLowerCase()),
        typeLabel
      );
      setTriggerFilter(false);
    }
  }, [carModel?.values?.find((item) => item?.selected), dataCoupon]);

  useEffect(() => {
    setTimeout(() => {
      if (collectDataBanner.length > 0 && bannerImg && isGTMReady) {
        sendDataInChunks(
          collectDataBanner,
          collectDataBanner.length,
          (chunk) => {
            eventViewBannerCoupon(chunk, categoryGTM);
          },
          setcollectDataBanner,
          typeID //perlu di noted
        );
      }
    }, 1500);
  }, [collectDataBanner, isGTMReady]);

  return (
    <React.Fragment>
      <BreadCrumbs
        isMobileScreen={false}
        items={breadcrumbItems}
        position="md:top-[105px] lg:top-[105px] xl:top-[120px]"
        isUsingDefaultAnchor={accType.includes(typeID)}
      />
      <ServiceBannerSection
        typeService={typeLabel}
        bannerId={bannerId}
        bannerTitle={bannerTitle}
        bannerDesc={bannerDesc}
        bannerImg={bannerImg}
        bannerWidth={bannerWidth}
        bannerHeight={bannerHeight}
        bannerAltImg={bannerAltImg}
        bannerLink={bannerLink}
        styleMy="my-0"
        handleCollectDataLayer={(data) => setcollectDataBanner((prev) => [...prev, data])}
        category={categoryGTM}
        isForAccList={isForAccList}
      />

      <div className="lg:container xl:px-0">
        <div className="lg:flex lg:gap-6">
          {isForAccList ? (
            filterAccessories
          ) : (
            <FilterServices
              servicePackagesForFilter={servicePackagesForFilter}
              sortsList={sortsList}
              carModel={carModel}
              specialOffer={specialOffer}
              freeTextSearch={freeTextSearch}
              typeID={typeID}
              setTriggerGTM={setTriggerGTM}
              setTriggerFilter={setTriggerFilter}
              impressionData={{
                title: bannerTitle || '',
                carModels: selectedCarModels,
                breadcrumbItems,
                customerNo: userData?.customerNo,
                sectionName: SECTION_NAME_SERVICE_COUPON.FILTER,
                filterValue: {
                  search: freeTextSearch,
                  special_offer:
                    (specialOffer?.values?.filter((item) => item?.selected)?.length > 0 &&
                      specialOffer?.name?.toLowerCase() === 'isdiscount' &&
                      'diskon') ||
                    '',
                  car_model:
                    carModel?.values
                      ?.filter((item) => item.selected)
                      .map((item) => item.name)
                      .join(',') || '',
                  order_by: sortsList?.find((item) => item.selected)?.name || '',
                },
                carCategory:
                  tabList?.find((item) => item.selected)?.name?.toLowerCase() !== 'semua'
                    ? tabList?.find((item) => item.selected)?.name
                    : '',
              }}
              feature={feature}
            />
          )}

          <ServicesListSection
            servicePackagesForFilter={servicePackagesForFilter}
            typeID={typeID}
            tabList={tabList}
            servicePackages={servicePackages}
            onClickSorts={setViewSortModal}
            onClickFilter={setViewFilterModal}
            filterCount={filterCount}
            handleCollectDataLayer={(data: any) => setcollectDataList((prev) => [...prev, data])}
            userCarsData={userData?.vehicleDetails || []}
            freeTextSearch={freeTextSearch}
            isForAccList={isForAccList}
            pagination={pagination}
            paginationBaseUrl={paginationBaseUrl}
            categoryFilter={categoryFilter}
            impressionData={{
              title: bannerTitle || '',
              carModels: selectedCarModels,
              breadcrumbItems,
              customerNo: userData?.customerNo,
              sectionName: SECTION_NAME_SERVICE_COUPON.FILTER,
              filterValue: {
                search: freeTextSearch,
                special_offer:
                  (specialOffer?.values?.filter((item) => item?.selected)?.length > 0 &&
                    specialOffer?.name?.toLowerCase() === 'isdiscount' &&
                    'diskon') ||
                  '',
                car_model:
                  carModel?.values
                    ?.filter((item) => item.selected)
                    .map((item) => item.name)
                    .join(',') || '',
                order_by: sortsList.find((item) => item.selected)?.name || '',
              },
              carCategory:
                tabList?.find((item) => item.selected)?.name?.toLowerCase() !== 'semua'
                  ? tabList?.find((item) => item.selected)?.name
                  : '',
            }}
            feature={feature}
          />
        </div>
      </div>

      <InfoSection
        info={infoSectionData}
        sectionClassName={`!mt-5 !mb-6 lg:!mt-10 !px-0 lg:!mb-${typeID.includes('accessories') ? '6' : '0'}`}
        feature={feature}
        impressionData={{
          breadcrumbItems,
          pageTitle: bannerTitle || '',
          carModels: selectedCarModels,
        }}
      />
      <FaqAccordionNoscript title={faqs?.title} faqs={faqs?.faqList} />
      {typeID.includes('accessories') ? (
        !!faqs.faqList.length && (
          <FaqAccordion
            title={faqs?.title}
            faqs={faqs?.faqList}
            containerClassname="my-6 px-0 lg:mb-20 lg:mt-8"
            divClassName={''}
          />
        )
      ) : (
        <FaqAccordion
          title={faqs?.title}
          faqs={faqs?.faqList}
          containerClassname="my-6 px-0 lg:mb-20 lg:mt-8"
          divClassName={''}
          feature={feature}
          impressionData={{
            pageTitle: bannerTitle || '',
            breadcrumbItems,
            carModels: selectedCarModels,
          }}
        />
      )}

      {screenTab && (
        <>
          <BreadCrumbs
            isMobileScreen={true}
            items={breadcrumbItems}
            isUsingDefaultAnchor={accType.includes(typeID)}
          />

          <ModalMobile
            visible={viewSortModal}
            height={'h-auto'}
            title={'Urutkan Berdasarkan'}
            icon={<SortIcon />}
            onClose={() => setViewSortModal(false)}
            scrollBehaviour
          >
            <div className={`h-[100dvh] text-center flex flex-col items-center justify-between`}>
              <SortModalContent
                sortsList={sortsList}
                setTriggerGTM={setTriggerGTM}
                setViewSortModal={setViewSortModal}
                feature={feature}
                impressionData={{
                  title: bannerTitle || '',
                  carModels: selectedCarModels,
                  breadcrumbItems,
                  customerNo: userData?.customerNo,
                  sectionName: SECTION_NAME_SERVICE_COUPON.FILTER,
                  filterValue: {
                    search: freeTextSearch,
                    special_offer:
                      (specialOffer?.values?.filter((item) => item?.selected)?.length > 0 &&
                        specialOffer?.name?.toLowerCase() === 'isdiscount' &&
                        'diskon') ||
                      '',
                    car_model:
                      carModel?.values
                        ?.filter((item) => item.selected)
                        .map((item) => item.name)
                        .join(',') || '',
                    order_by: sortsList.find((item) => item.selected)?.name || '',
                  },
                  carCategory:
                    tabList?.find((item) => item.selected)?.name?.toLowerCase() !== 'semua'
                      ? tabList?.find((item) => item.selected)?.name
                      : '',
                }}
                breadcrumbItems={breadcrumbItems}
              />
            </div>
          </ModalMobile>

          <ModalMobile
            visible={viewFilterModal}
            height={'h-[100dvh]'}
            title={'Filter Pencarian'}
            icon={<FilterIcon />}
            onClose={() => setViewFilterModal(false)}
            scrollBehaviour
          >
            <div className={`h-[100dvh] text-center flex flex-col items-center justify-between`}>
              <>
                {accType.includes(typeID) ? (
                  <FilterModalContentAccessories
                    typeID={typeID}
                    minPrice={minPrice}
                    maxPrice={maxPrice}
                    slideMin={slideMin}
                    slideMax={slideMax}
                    setTriggerFilter={setTriggerFilter}
                    carModel={carModel}
                    categoryFilter={categoryFilter}
                    specialOffer={specialOffer}
                    pickUpOption={pickUpOption}
                    typeAccFilter={typeAccFilter}
                    isPLPCategory={isPLPCategory}
                  />
                ) : (
                  <FilterModalContentServicePackages
                    carModel={carModel}
                    specialOffer={specialOffer}
                    typeID={typeID}
                    setTrigger={setTriggerFilter}
                    impressionData={{
                      title: bannerTitle || '',
                      carModels: selectedCarModels,
                      breadcrumbItems,
                      customerNo: userData?.customerNo,
                      sectionName: SECTION_NAME_SERVICE_COUPON.FILTER,
                      filterValue: {
                        search: freeTextSearch,
                        special_offer:
                          (specialOffer?.values?.filter((item) => item?.selected)?.length > 0 &&
                            specialOffer?.name?.toLowerCase() === 'isdiscount' &&
                            'diskon') ||
                          '',
                        car_model:
                          carModel?.values
                            ?.filter((item) => item.selected)
                            .map((item) => item.name)
                            .join(',') || '',
                        order_by: sortsList.find((item) => item.selected)?.name || '',
                      },
                      carCategory:
                        tabList?.find((item) => item.selected)?.name?.toLowerCase() !== 'semua'
                          ? tabList?.find((item) => item.selected)?.name
                          : '',
                    }}
                    feature={feature}
                  />
                )}
                <div className={`sticky bottom-0 w-full z-[22] lg:hidden`}>
                  <BtnConfirm
                    id="btn-filter-modal"
                    block={true}
                    className="bg-supportiveRed text-white"
                    size="large"
                    iconType="icon"
                    onClick={() => {
                      setViewFilterModal(false);
                      eventFilterCoupon(
                        dataCoupon,
                        carModel?.values
                          ?.filter((item) => item?.selected === true)
                          ?.map((item) => item?.name?.toLowerCase()) || '',
                        typeLabel
                      );
                    }}
                  >
                    <div className="flex justify-end items-center gap-3">
                      <div className="flex flex-col text-end py-1.5">
                        <p className="text-base font-bold uppercase">Pilih</p>
                      </div>
                      <ArrowForward size={20} color="#FFFFFF" />
                    </div>
                  </BtnConfirm>
                </div>
              </>
            </div>
          </ModalMobile>
        </>
      )}
    </React.Fragment>
  );
};

export default ServiceListingPageTemplate;
